<template>
	<div class="animated fadeIn">


		<div class="row">
			<div class="col-xs-12">
				<PersonBlock :person="person"/>
			</div>
		</div>

	</div>

</template>
<script>
	import {Notification} from 'element-ui';
	import Person from '../../../common/model/person/Person'
	import PersonBlock from "../../../lobby/view/person/widget/PersonBlock.vue";

	export default {

		data () {
			return {
				person: new Person()
			}
		},
		components: {
			PersonBlock
		},
		methods: {},
		mounted(){
			let that = this;
			this.person.id = this.$store.state.route.params.id;
			if (this.person.id) {
				this.person.httpDetail();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Detail.vue?3091bd90